var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17381",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12846",
    d: "M10.393 12.11a3.75 3.75 0 11-5.3 0 3.75 3.75 0 015.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12847",
    d: "M22.882 10.329l3.125-3.125-3.125-3.125"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12852",
    d: "M22.882 25.921l3.125-3.125-3.125-3.125"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12850",
    d: "M23.897 22.78s-1.59.035-3.316 0-2.467.075-3.271-.852-.625-1.327-.7-3.639-2.4-3.07-3.617-3.049a11.334 11.334 0 01-1.25 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12851",
    d: "M23.897 7.219s-1.59-.035-3.316 0-2.467-.075-3.271.852-.625 1.327-.7 3.638-2.4 3.071-3.615 3.05a11.335 11.335 0 00-1.25 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12849",
    d: "M0 0h30v30H0z",
    fill: "none"
  })));
}
export default SvgChoices;


//////////////////
// WEBPACK FOOTER
// ./src/icons/choices.svg
// module id = 458
// module chunks = 11